import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col gap-4 md:gap-8 place-self-center items-center" }
const _hoisted_2 = { class: "relative w-full h-[140px] overflow-hidden" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "grid place-content-center bg-blue-4 p-2 w-full h-full"
}
const _hoisted_5 = { class: "w-11/12 max-w-screen-xl" }
const _hoisted_6 = { class: "flex flex-col gap-4 sm:gap-8 m-auto w-11/12 max-w-screen-xl" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-between gap-4 items-end sm:items-baseline"
}
const _hoisted_8 = {
  key: 1,
  role: "list",
  class: "divide-y divide-gray-200"
}
const _hoisted_9 = { class: "py-2 sm:px-0" }
const _hoisted_10 = { class: "px-0 py-2 flex justify-between" }
const _hoisted_11 = { class: "-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap w-full py-2" }
const _hoisted_12 = { class: "ml-4 flex flex-wrap" }
const _hoisted_13 = { class: "flex flex-wrap gap-x-4 items-center" }
const _hoisted_14 = { class: "text-sm text-gray-500" }
const _hoisted_15 = { class: "text-sm text-gray-500 flex gap-2 items-center" }
const _hoisted_16 = { class: "text-sm text-gray-500 flex gap-2 items-center" }
const _hoisted_17 = { class: "ml-4 flex-shrink-0" }
const _hoisted_18 = { class: "py-2 sm:px-0" }
const _hoisted_19 = { class: "px-0 py-2 flex justify-between" }
const _hoisted_20 = { class: "-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap w-full py-2" }
const _hoisted_21 = { class: "ml-4 flex flex-wrap" }
const _hoisted_22 = { class: "flex flex-wrap gap-x-4 items-center" }
const _hoisted_23 = { class: "text-sm text-gray-500" }
const _hoisted_24 = { class: "text-sm text-gray-500 flex gap-2 items-center" }
const _hoisted_25 = { class: "text-sm text-gray-500 flex gap-2 items-center" }
const _hoisted_26 = { class: "ml-4 flex-shrink-0" }
const _hoisted_27 = {
  class: "w-11/12 max-w-screen-xl py-4 mx-auto",
  id: "footerBg"
}
const _hoisted_28 = { class: "flex items-start flex-row justify-between gap-8" }
const _hoisted_29 = { class: "flex flex-row items-start gap-4" }
const _hoisted_30 = { class: "flex place-content-center bg-white overflow-hidden px-1 rounded-md w-[80px]" }
const _hoisted_31 = { class: "text-xs flex flex-col gap-2 text-white" }
const _hoisted_32 = {
  class: /*@__PURE__*/_normalizeClass(['flex flex-row gap-x-2 gap-y-4 justify-between text-xs'])
}
const _hoisted_33 = { class: "text-left" }
const _hoisted_34 = { class: "mt-2" }
const _hoisted_35 = { class: "space-y-2 text-left mx-auto" }
const _hoisted_36 = {
  key: 0,
  class: "items-center text-gray-2 flex mx-auto"
}
const _hoisted_37 = { class: "sm:place-self-start transition hover:text-gray-2/75" }
const _hoisted_38 = {
  key: 1,
  class: "items-center text-gray-2 flex mx-auto"
}
const _hoisted_39 = { class: "sm:place-self-start transition hover:text-gray-2/75" }
const _hoisted_40 = { class: "items-center text-gray-2 flex mx-auto" }
const _hoisted_41 = { class: "sm:place-self-start transition hover:text-gray-2/75" }
const _hoisted_42 = { class: "flex flex-col text-left" }
const _hoisted_43 = { class: "pt-4 mt-4 border-t border-gray-2 text-xs" }
const _hoisted_44 = { class: "text-center sm:flex sm:justify-between md:text-left grid grid-cols-1 xl:grid-cols-3 items-center gap-4" }
const _hoisted_45 = { class: "flex justify-center gap-2 md:gap-3 sm:justify-start items-center" }
const _hoisted_46 = { class: "text-white transition hover:text-blue-4/75" }
const _hoisted_47 = { class: "text-white transition hover:text-blue-4/75" }
const _hoisted_48 = { class: "text-white transition hover:text-blue-4/75" }
const _hoisted_49 = { class: "text-white transition hover:text-blue-4/75" }
const _hoisted_50 = { class: "text-white transition hover:text-blue-4/75" }
const _hoisted_51 = { class: "text-white transition hover:text-blue-4/75" }

import { ref, onMounted, watch, computed } from "vue";
import { Profile } from "@/models/Profile";
import { useStore } from "vuex";
import Logotype from "@/features/shared/components/ui/Logotype.vue";
import { MainContainer } from "@/models/MainContainer";
// import { CustomTheme } from "@/models/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'PositionsPreView',
  props: {
  banner: {
    type: String,
    default: "",
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const isLoaded = ref(false);
const containerByDNS = ref<Profile>(null);

// const theme = ref(new CustomTheme())

// // Använd watch för att observera ändringar i temat
// watch(() => store.getters.getContainerTheme, (newTheme) => {
//   theme.value = newTheme;

//   // Kolla om temat är laddat
//   if (theme.value) {
//     // Nu kan du använda det nya temat här och uppdatera din komponent enligt behov
//     console.log("Ny bakgrundsfärg:", theme.value.backgroundColor.mainContent);
//     console.log("Ny textfärg:", theme.value.textColor.otherText);
//     console.log("Ny borderRadius:", theme.value.button.borderRadius);
//     // Uppdatera din komponent med de nya tematiska värdena
//   }
// });

onMounted(async () => {
  await store.dispatch("loadContainerTheme");
  try {
    await store.dispatch("loadContainerTheme");
    containerByDNS.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
    isLoaded.value = true;
  } catch (error) {
    console.error("Error loading public container:", error);
  }
});

const themedText = computed(() => store.getters.getContainerThemedText);
const themedButton = computed(() => store.getters.getContainerThemedButton);
const themedBackground = computed(
  () => store.getters.getContainerThemedBackground
);
const themedIcon = computed(() => store.getters.getContainerThemedIcon);

return (_ctx: any,_cache: any) => {
  return (isLoaded.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle({ backgroundColor: themedBackground.value?.mainContent }),
        class: "mainBg border rounded-md overflow-hidden shadow-lg shadow-darkGray-1/40 border-gray-100 grid w-full"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (props.banner && props.banner !== '')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: props.banner,
                  class: "w-full h-full object-cover min-h-[200px] max-h-[400px]"
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "fas fa-image text-4xl text-gray-300" }, null, -1)
                ])))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", {
              style: _normalizeStyle({ color: themedText.value?.workAtText }),
              class: _normalizeClass(`text-sm font-semibold leading-8 tracking-tight workAtText`)
            }, " Jobba hos " + _toDisplayString(_ctx.$store.getters.container?.name), 5)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (isLoaded.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", {
                  style: _normalizeStyle({ color: themedText.value?.otherText }),
                  class: "mt-2 text-base font-bold tracking-tight ${the} text-gray-900"
                }, " Just nu har vi 2 lediga tjänster ", 4)
              ]))
            : _createCommentVNode("", true),
          (isLoaded.value)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                _createElementVNode("li", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", {
                            style: _normalizeStyle({ color: themedText.value?.otherText }),
                            class: _normalizeClass(`text-sm font-medium leading-6 ${themedText.value?.otherText} text-gray-900 cursor-pointer`)
                          }, " Namn på annons ", 6)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("i", {
                            style: _normalizeStyle({ color: themedIcon.value?.positionIcon1 }),
                            class: "fa-solid fa-building place-self-center text-blue-2"
                          }, null, 4)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("i", {
                            style: _normalizeStyle({ color: themedIcon.value?.positionIcon2 }),
                            class: "fa-solid fa-location-dot place-self-center text-pink-1"
                          }, null, 4),
                          _createElementVNode("p", {
                            style: _normalizeStyle({ color: themedText.value?.detailText }),
                            class: "text-darkGray-3"
                          }, " Stockholm ", 4)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("i", {
                            style: _normalizeStyle({ color: themedIcon.value?.positionIcons }),
                            class: "fa-regular fa-calendar-check place-self-center text-azure-1"
                          }, null, 4)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", {
                          style: _normalizeStyle({
                    color: themedButton.value?.textColor,
                    backgroundColor: themedButton.value?.backgroundColor,
                    borderRadius: themedButton.value?.borderRadius,
                  }),
                          type: "button",
                          class: _normalizeClass(`${
                    themedButton.value?.borderRadius || 'rounded-md'
                  } coloredButton bg-blue-1 relative inline-flex items-center border border-transparent px-4 py-2 text-xs font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`)
                        }, " Läs mer och ansök ", 6)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("li", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", {
                            style: _normalizeStyle({ color: themedText.value?.otherText }),
                            class: _normalizeClass(`text-sm font-medium leading-6 text-gray-900 cursor-pointer`)
                          }, " Namn på annons ", 4)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("i", {
                            style: _normalizeStyle({ color: themedIcon.value?.positionIcon1 }),
                            class: "fa-solid fa-building place-self-center text-blue-2"
                          }, null, 4)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("i", {
                            style: _normalizeStyle({ color: themedIcon.value?.positionIcon2 }),
                            class: "fa-solid fa-location-dot place-self-center text-pink-1"
                          }, null, 4),
                          _createElementVNode("p", {
                            style: _normalizeStyle({ color: themedText.value?.detailText }),
                            class: "text-darkGray-3"
                          }, " Stockholm ", 4)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("i", {
                            style: _normalizeStyle({ color: themedIcon.value?.positionIcons }),
                            class: "fa-regular fa-calendar-check place-self-center text-azure-1"
                          }, null, 4)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("span", {
                          style: _normalizeStyle({
                    color: themedButton.value?.textColor,
                    backgroundColor: themedButton.value?.backgroundColor,
                    borderRadius: themedButton.value?.borderRadius,
                  }),
                          type: "button",
                          class: _normalizeClass(`${
                    themedButton.value?.borderRadius || 'rounded-md'
                  } bg-blue-1 relative inline-flex items-center border border-transparent px-4 py-2 text-xs font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`)
                        }, " Läs mer och ansök ", 6)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("footer", {
          style: _normalizeStyle({ backgroundColor: themedBackground.value?.footer }),
          class: "footerBg bg-darkGray-1 mt-2"
        }, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(Logotype, {
                    logo: containerByDNS.value?.CompanyLogo?.data
                  }, null, 8, ["logo"])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("p", {
                    style: _normalizeStyle({ color: themedText.value?.footerText }),
                    class: "font-medium text-center md:text-left"
                  }, _toDisplayString(_ctx.$store.getters.container.name), 5)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("p", {
                    style: _normalizeStyle({ color: themedText.value?.contactText }),
                    class: "contactText text-sm font-medium text-blue-3.5"
                  }, " Kontakta oss ", 4),
                  _createElementVNode("nav", _hoisted_34, [
                    _createElementVNode("ul", _hoisted_35, [
                      (containerByDNS.value?.PhoneNumber?.data)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                            _createElementVNode("span", _hoisted_37, [
                              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-phone w-[32px]" }, null, -1)),
                              _createTextVNode(_toDisplayString(containerByDNS.value?.PhoneNumber?.data), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (containerByDNS.value?.Email?.data)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                            _createElementVNode("span", _hoisted_39, [
                              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-envelope w-[32px]" }, null, -1)),
                              _createTextVNode(_toDisplayString(containerByDNS.value?.Email?.data), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("li", _hoisted_40, [
                        _createElementVNode("span", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("span", null, [
                              _createElementVNode("span", {
                                class: "inline-block",
                                style: _normalizeStyle({ color: themedText.value?.footerText })
                              }, _cache[3] || (_cache[3] = [
                                _createElementVNode("i", { class: "block fas fa-map-marker-alt w-[32px] justify-center" }, null, -1)
                              ]), 4),
                              _createElementVNode("span", {
                                style: _normalizeStyle({ color: themedText.value?.footerText })
                              }, "Gatuadress", 4)
                            ]),
                            _createElementVNode("span", {
                              class: "ml-8",
                              style: _normalizeStyle({ color: themedText.value?.footerText })
                            }, " 123 45 Stad ", 4)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("ul", _hoisted_45, [
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_46, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "sr-only" }, "Facebook", -1)),
                      _createElementVNode("i", {
                        style: _normalizeStyle({ color: themedIcon.value?.footerIcon }),
                        class: "fab fa-facebook-f footerBgicon"
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_47, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "sr-only" }, "Instagram", -1)),
                      _createElementVNode("i", {
                        style: _normalizeStyle({ color: themedIcon.value?.footerIcon }),
                        class: "fab fa-instagram footerBgicon"
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "sr-only" }, "X", -1)),
                      _createElementVNode("i", {
                        style: _normalizeStyle({ color: themedIcon.value?.footerIcon }),
                        class: "fab fa-x-twitter footerBgicon"
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_49, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "sr-only" }, "LinkedIn", -1)),
                      _createElementVNode("i", {
                        style: _normalizeStyle({ color: themedIcon.value?.footerIcon }),
                        class: "fab fa-linkedin-in footerBgicon"
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_50, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sr-only" }, "GitHub", -1)),
                      _createElementVNode("i", {
                        style: _normalizeStyle({ color: themedIcon.value?.footerIcon }),
                        class: "fab fa-github footerBgicon"
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_51, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "sr-only" }, "YouTube", -1)),
                      _createElementVNode("i", {
                        style: _normalizeStyle({ color: themedIcon.value?.footerIcon }),
                        class: "fab fa-youtube footerBgicon"
                      }, null, 4)
                    ])
                  ])
                ]),
                _createElementVNode("p", {
                  style: _normalizeStyle({ color: themedText.value?.footerText }),
                  class: "text-xs text-gray-3 sm:order-first sm:mt-0"
                }, [
                  _cache[10] || (_cache[10] = _createTextVNode(" I samarbete med ")),
                  _createElementVNode("span", {
                    style: _normalizeStyle({ color: themedText.value?.footerText }),
                    class: "text-white transition hover:text-white/75"
                  }, "ansökningsportal.se", 4)
                ], 4)
              ])
            ])
          ])
        ], 4)
      ], 4))
    : _createCommentVNode("", true)
}
}

})